import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Search from './Search';
// import Message from './Message';
// import Profile from './Profile';
// import Localization from './Localization';
import Notification from './Notification';
// import FullScreen from './FullScreen';
import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import useRules from 'hooks/useRules';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const { isAdmin, hasRule, isExternalClient } = useRules();
  // Equipe interna com a regra de leitura; o login "Cliente" (293 usuários) não ganha o sino.
  const canSeeNotifications = !isExternalClient && (isAdmin || hasRule('notifications.read'));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}

      {/* Busca (produtos/pedidos/clientes) — só no desktop; no mobile ela mora dentro do menu "⋮" (MobileSection) */}
      {!downLG && (
        <Box sx={{ width: 260 }}>
          <Search />
        </Box>
      )}

      {/* Spacer para empurrar os itens para a direita */}
      <Box sx={{ flexGrow: 1 }} />

      {/* Sino de notificações — só para quem tem a regra de leitura (ex.: Logística recebe aviso de pedido em separação) */}
      {canSeeNotifications && <Notification />}

      {downLG && <MobileSection />}
    </>
  );
}
